function initMediaListing(sectionId, perPage) {
  var root = document.getElementById(sectionId);
  if (!root) return;

  // Avoid attaching duplicate listeners if boot() runs more than once
  if (root.dataset.mlInitialized === 'true') return;
  root.dataset.mlInitialized = 'true';

  var tabs = root.querySelectorAll('.ml-tab');
  var grid = root.querySelector('.ml-grid');
  var cards = Array.prototype.slice.call(grid.querySelectorAll('.ml-card'));
  var emptyState = root.querySelector('.ml-empty--filtered');
  var paginationEl = root.querySelector('.ml-pagination');

  var state = {
    filter: 'all',
    page: 1
  };

  function getFilteredCards() {
    return cards.filter(function (card) {
      return state.filter === 'all' || card.getAttribute('data-type') === state.filter;
    });
  }

  function render() {
    var filtered = getFilteredCards();
    var totalPages = Math.max(1, Math.ceil(filtered.length / perPage));
    if (state.page > totalPages) state.page = totalPages;

    var start = (state.page - 1) * perPage;
    var end = start + perPage;

    // Show/hide cards
    cards.forEach(function (card) {
      card.hidden = true;
    });
    filtered.slice(start, end).forEach(function (card) {
      card.hidden = false;
    });

    // Empty state
    emptyState.hidden = filtered.length !== 0;

    renderPagination(totalPages);
  }

  function renderPagination(totalPages) {
    paginationEl.innerHTML = '';

    if (totalPages <= 1) {
      paginationEl.hidden = true;
      return;
    }
    paginationEl.hidden = false;

    var prevBtn = document.createElement('button');
    prevBtn.type = 'button';
    prevBtn.className = 'ml-page-btn';
    prevBtn.textContent = '‹';
    prevBtn.disabled = state.page === 1;
    prevBtn.addEventListener('click', function () {
      goToPage(state.page - 1);
    });
    paginationEl.appendChild(prevBtn);

    for (var i = 1; i <= totalPages; i++) {
      (function (pageNum) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ml-page-btn' + (pageNum === state.page ? ' is-active' : '');
        btn.textContent = String(pageNum);
        btn.addEventListener('click', function () {
          goToPage(pageNum);
        });
        paginationEl.appendChild(btn);
      })(i);
    }

    var nextBtn = document.createElement('button');
    nextBtn.type = 'button';
    nextBtn.className = 'ml-page-btn';
    nextBtn.textContent = '›';
    nextBtn.disabled = state.page === totalPages;
    nextBtn.addEventListener('click', function () {
      goToPage(state.page + 1);
    });
    paginationEl.appendChild(nextBtn);
  }

  function goToPage(pageNum) {
    state.page = pageNum;
    render();
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      tabs.forEach(function (t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', 'false');
      });
      tab.classList.add('is-active');
      tab.setAttribute('aria-selected', 'true');

      state.filter = tab.getAttribute('data-filter');
      state.page = 1;
      render();
    });
  });

  render();
}